<div class="card shadow-lg">
  <div class="card-title">
    <div class="d-flex align-items-center">
      <span
        class="material-symbols-outlined me-3 dash-icon d-flex align-items-center justify-content-center"
        [ngStyle]="{'background-color': iconBg, 'color': iconColor}">
        {{ icon }}
      </span>
      <div class="d-flex flex-column justify-content-center">
        <div><h4>{{ title }}</h4></div>
      </div>
    </div>
  </div>
  <div class="card-body">{{studentValue}}</div>
  <div class="text-muted">Students Participating</div>
  <div>
  </div>
  <div class="card-footer">
    <div style="font-size: 18px">{{teacherValue}}</div>
    <div class="text-muted" style="font-size: smaller">Teachers Involved</div>
  </div>
</div>
